import React from 'react';
import { Button } from './ui/button';
import bridal from "../assets/images/bridal.jpg";

const BridalHairMakeup = () => {
  return (
    <div className="pt-20">
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Bridal Hair & Makeup</h1>
              <p className="text-gray-700 leading-relaxed mb-4">
                Come visit one of our JOKER & QUINN specialists for a consultation and trial to ensure that everything is flawless on your extra-special wedding day.
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                We create stunning bridal looks that make you feel confident and beautiful on your most important day.
              </p>
              <Button
                className="bg-black hover:bg-gray-800 text-white px-8 py-4 rounded-full"
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              >
                Book Appointment
              </Button>
            </div>
            <div>
              <img src={bridal} alt="Bridal Hair and Makeup" className="rounded-lg shadow-xl w-full h-[500px] object-cover" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BridalHairMakeup;
